export default {
  methods: {
    navigateTo(path) {
      this.$router.push({ path : path });
    }
  }
}
